<div cesFullscreen #fs="cesFullscreen" class="flex flex-col flex-1 min-h-0 gap-(--space-4)">
  <div class="flex flex-wrap items-center gap-(--space-3) justify-end">
    <ces-date-navigation
      [startDate]="dateNavService.startDate()"
      [endDate]="dateNavService.endDate()"
      [canNavigate]="dateNavService.canNavigate()"
      [endDateDisabled]="dateNavService.endDateDisabled()"
      [refreshDisabled]="!canRefresh()"
      (startDateChange)="dateNavService.startDate.set($event)"
      (endDateChange)="dateNavService.endDate.set($event)"
      (navigatePrevious)="dateNavService.navigatePrevious()"
      (navigateNext)="dateNavService.navigateNext()"
      (refresh)="onRefresh()" />
    @if (fs.isFullscreen()) {
      <div class="flex items-center gap-(--space-2)">
        <p-toggleswitch inputId="hide-empty" [ngModel]="hideEmptyRows()" (ngModelChange)="onHideEmptyRowsChange($event)" />
        <label for="hide-empty" class="text-sm cursor-pointer">{{ 'tables.data.hideEmptyRows' | transloco }}</label>
      </div>
    }
    @if (hasActiveFilters()) {
      <ces-button-secondary icon="filter_alt_off" [label]="'common.buttons.clear' | transloco" (onClick)="clearAllFilters()" />
    }
    <ces-button-secondary icon="content_copy" [label]="copyButtonLabel()" [disabled]="copyDisabled()" (onClick)="onCopyClick()" />
    <ces-button-secondary
      [label]="fs.isFullscreen() ? ('common.buttons.exitFullscreen' | transloco) : ('common.buttons.fullscreen' | transloco)"
      [icon]="fs.isFullscreen() ? 'fullscreen_exit' : 'fullscreen'"
      (onClick)="fs.toggle()" />
  </div>

  @if (!fs.isFullscreen()) {
    <div class="flex items-center gap-(--space-2)">
      <p-toggleswitch inputId="hide-empty" [ngModel]="hideEmptyRows()" (ngModelChange)="onHideEmptyRowsChange($event)" />
      <label for="hide-empty" class="text-sm cursor-pointer">{{ 'tables.data.hideEmptyRows' | transloco }}</label>
    </div>
  }

  @if (showStaleWarning()) {
    <div role="status" class="flex justify-center items-center px-2 py-1 bg-[#F6F6F8] rounded">
      <span class="text-[13px] text-[#9191A1]">{{ 'tables.data.staleWarning' | transloco }}</span>
    </div>
  }

  @if (exportProgress()) {
    <div role="status" aria-live="polite" class="flex flex-col gap-(--space-1) px-2 py-1 bg-[#F6F6F8] rounded">
      <span class="text-[13px] text-[#9191A1]">{{ 'tables.data.exportInProgress' | transloco: exportStatusParams() }}</span>
      <p-progressbar [value]="exportPercent()" [showValue]="false" [style]="{ height: '4px' }" />
    </div>
  }

  @if (isLoading()) {
    <ces-grid-skeleton
      [lines]="10"
      [columns]="['', '', '', '', '']"
      [widths]="['8rem', '', '', '', '']"
      [heights]="['1.5rem', '1.5rem', '1.5rem', '1.5rem', '1.5rem']" />
  } @else if (loadError()) {
    <div
      role="alert"
      aria-live="assertive"
      class="flex flex-col items-center justify-center py-(--space-8) text-center bg-(color:--p-surface-50) rounded-(--radius-md)">
      <i class="pi pi-exclamation-triangle text-4xl text-(color:--p-red-500) mb-(--space-3)" aria-hidden="true"></i>
      <p class="text-(color:--text-primary) font-medium mb-(--space-2)">{{ 'tables.data.loadError.title' | transloco }}</p>
      <p class="text-(color:--text-secondary) text-sm">{{ 'tables.data.loadError.hint' | transloco }}</p>
    </div>
  } @else if (showNeedsRefresh()) {
    <div class="flex flex-col items-center justify-center py-(--space-8) text-center bg-(color:--p-surface-50) rounded-(--radius-md)">
      <i class="pi pi-refresh text-4xl text-(color:--p-primary-color) mb-(--space-3)" aria-hidden="true"></i>
      <p class="text-(color:--text-primary) font-medium mb-(--space-2)">{{ 'tables.data.needsRefresh.title' | transloco }}</p>
      <p class="text-(color:--text-secondary) text-sm">{{ 'tables.data.needsRefresh.hint' | transloco }}</p>
    </div>
  } @else if (columns().length === 0) {
    <div class="flex flex-col items-center justify-center py-(--space-8) text-center bg-(color:--p-surface-50) rounded-(--radius-md)">
      <i class="pi pi-table text-4xl text-(color:--p-surface-400) mb-(--space-2)" aria-hidden="true"></i>
      <p class="text-(color:--text-secondary)">{{ 'tables.data.noMeasures' | transloco }}</p>
    </div>
  } @else if (useSSRM()) {
    <ag-grid-angular
      [localeText]="localeText"
      class="ag-theme-quartz w-full flex-1 min-h-[180px]"
      [style.height]="fs.isFullscreen() ? 'calc(100vh - 80px)' : null"
      [columnDefs]="columnDefs()"
      [defaultColDef]="defaultColDef"
      [gridOptions]="ssrmGridOptions"
      (gridReady)="onSsrmGridReady($event)" />
  } @else {
    <ag-grid-angular
      class="ag-theme-quartz w-full flex-1 min-h-[180px]"
      [style.height]="fs.isFullscreen() ? 'calc(100vh - 80px)' : null"
      [rowData]="gridRowData()"
      [columnDefs]="columnDefs()"
      [defaultColDef]="defaultColDef"
      [gridOptions]="gridOptions"
      (gridReady)="onClientGridReady($event)" />
  }
</div>
